import { render, staticRenderFns } from "./ym-profit-page.vue?vue&type=template&id=671ba159&scoped=true&"
import script from "./ym-profit-page.vue?vue&type=script&lang=js&"
export * from "./ym-profit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ba159",
  null
  
)

export default component.exports